class HowItWorksModal extends HTMLElement {
  #abortController;
  #launchBtn
  #modal
  #video
  #videoContainer
  #actionDiv

  constructor() {
    super();
    this.#modal = this.querySelector('configurator-modal');
    this.#video = this.#modal.querySelector('iframe[data-video]');
    this.#videoContainer = this.#video.parentElement;
    this.#actionDiv = this.#modal.querySelector('[data-action-wrap]');
  }

  connectedCallback() {
    if (!this.#abortController) this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    this.#modal.addEventListener('modalevent', (e) => {
      if (e.detail.name === 'video') {
        if (!this.#video.parentElement) {
          this.#videoContainer.appendChild(this.#video);
        }
        this.#actionDiv.dataset.show = 'false';
        this.#video.dataset.show = 'true';
      }
      if (e.detail.name === 'close') {
        this.#actionDiv.dataset.show = 'true';
        this.#video.dataset.show = 'false';
        this.#video.remove();
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['launch-button-selector'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'launch-button-selector' && newValue && newValue !== '') {
      this.#launchBtn = document.querySelector(newValue);
      this.style.display = 'block';

      if (!this.#abortController) this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#launchBtn.addEventListener('click', (e) => {
        this.#modal.dataset.show = 'true';
      }, { signal });
    }
  }
}

customElements.define('how-it-works-modal', HowItWorksModal);